module.exports = __webpack_public_path__ + "static/img/feature02_upgrade.be6346b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/feature02_upgrade.jpg
// module id = pPgB
// module chunks = 1